import React, {useRef, useState} from 'react';
import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';
import styles from './styles.module.scss';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { isFunc } from "@utils/functions";

const StandardNavigationSubmenu = ({
                                     label,
                                     items,//array of objects that contain `label`, `link` and `action` fields
                                     color = 'inherit',
                                     className = styles.navButton,
                                   }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const getNormalizedLabel = (label) => typeof label === 'string' ? label : String(label);
  const getIdf = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event, action) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    if (isFunc(action)) action(event);

    setOpen(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  return (<>
    <Button
      color={color}
      onClick={handleToggle}
      className={className}
      data-testid={`navigation-button-submenu-main-header-${getIdf(getNormalizedLabel(label))}`}
      endIcon={<ArrowDropDownIcon />}
      ref={anchorRef}
    >
      {getNormalizedLabel(label)}
    </Button>
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      placement="bottom"
      className={styles.actionMenu}
      arrow={{ enabled: true }}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: 'center top' }}
        >
          <Paper className={styles.actionMenuPaper} elevation={1}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList id={`navigation-submenu-menu-list-grow-${getIdf(getNormalizedLabel(label))}`} onKeyDown={handleListKeyDown}>
                {items.map((it, idx) => (
                  <MenuItem
                    className={styles.menuItem}
                    onClick={(e) => handleClose(e, it.action)}
                    key={idx}
                    data-testid={`navigation-submenu-main-header-menuitem-${getIdf(getNormalizedLabel(label))}-${getIdf(getNormalizedLabel(it.label))}`}
                  >
                    {!!it.link ? (
                      <a
                        href={it.link}
                        onClick={(e) => { e.preventDefault(); }}
                        className={styles.anchorBlack}
                        data-testid={`navigation-submenu-main-header-link-${getIdf(getNormalizedLabel(label))}-${getIdf(getNormalizedLabel(it.label))}`}
                      >
                        {getNormalizedLabel(it.label)}
                      </a>
                    ) : (
                      getNormalizedLabel(it.label)
                    )}
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  </>
  );
};

export default StandardNavigationSubmenu;